module.exports = __webpack_public_path__ + "static/media/planNavLogo.cacd620d.svg";